module.exports = __webpack_public_path__ + "img/hailan.ec0d2b67.png";